<div class="modelContainer">
  <div class="">
    <button (click)="onCancelClick(false)" type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close>
      Close
    </button>
  </div>
  <div class="modelTitle heading2 alignCenter">
    <span *ngIf="data.displayType=='add'">Create Datasource</span>
    <span *ngIf="data.displayType=='view'">View Datasource</span>
    <span *ngIf="data.displayType=='edit'">Edit Datasource</span>
  </div>
  <div class="modelBody regularText datasource_form">
    <form [formGroup]="datasourceDetailForm">
      <div *ngIf="isLoading" class="svg-loader"></div>
      <div class="form-group row" *ngIf="!loadPage2">
        <label for="datasourceName" class="col-3 mandatory-field no-padding"><strong>Datasource Name</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="datasourceName" class="form-control" id="datasourceName" required />
        </div>
        <label for="tenantId" class="col-3 mandatory-field no-padding"><strong>Tenant Name</strong></label>
        <div class="col-3 zero-padding">
          <select id="tenantId" class="form-control select-btn" required formControlName="tenantId">
            <option *ngFor="let element of tenantList" [ngValue]="element.tenantId">{{element.tenantName}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row mt-3" *ngIf="loadPage2">
        <label for="masterDataTable" class="col-3 mandatory-field no-padding"><strong>Master Data Table</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="masterDataTable" class="form-control" id="masterDataTable" required />
        </div>
        <label for="idCol" class="col-3 mandatory-field no-padding"><strong>Id Col</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="idCol" class="form-control" id="idCol" required />
        </div>
      </div>
      <div class="form-group row mt-3" *ngIf="!loadPage2">
        <label for="datasourceTypeName" class="col-3 mandatory-field no-padding"><strong>Datasource Type</strong></label>
        <div class="col-3 zero-padding">
          <select id="datasourceTypeName" class="form-control select-btn" required formControlName="datasourceTypeName">
            <option *ngFor="let element of dataSourceTypesList" [ngValue]="element.datasourceTypeName">{{element.datasourceTypeName}}</option>
          </select>
        </div>
        <label *ngIf="datasourceDetailForm.get('datasourceTypeName').value == 'SQL Server'" for="datasourceTableName" class="col-3 mandatory-field no-padding"><strong>Datasource Table Name</strong></label>
        <div class="col-3 zero-padding" *ngIf="datasourceDetailForm.get('datasourceTypeName').value == 'SQL Server'">
          <input type="text" formControlName="datasourceTableName" class="form-control" id="datasourceTableName" required />
        </div>
      </div>
      <div class="form-group row mt-3" *ngIf="!loadPage2 && datasourceDetailForm.get('datasourceTypeName').value == 'Cosmos DB'">
        <label for="cosmosDbName" class="col-3 mandatory-field no-padding"><strong>Cosmos DB Name</strong></label>
        <div class="col-3 zero-padding" [matTooltip]="data.data.cosmosDbName">
          <input type="text" formControlName="cosmosDbName" class="form-control" id="cosmosDbName" required />
        </div>
        <label for="datasourceTableName" class="col-3 mandatory-field no-padding"><strong>Datasource Table Name</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="datasourceTableName" class="form-control" id="datasourceTableName" required />
        </div>
      </div>

      <div class="form-group row mt-3" *ngIf="loadPage2">
        <label for="representation" class="col-3 no-padding"><strong>Representation</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="representation" class="form-control" id="representation" required />
        </div>
        <label for="timeCol" class="col-3 mandatory-field no-padding"><strong>Time Col</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="timeCol" class="form-control" id="timeCol" required />
        </div>
      </div>
      <div class="form-group row mt-3" *ngIf="loadPage2">
        <label for="dataCharacteristic" class="col-3 no-padding"><strong>Data Characteristic</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="dataCharacteristic" class="form-control" id="dataCharacteristic" required />
        </div>
        <label for="valueCol" class="col-3 mandatory-field no-padding"><strong>Value Col</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="valueCol" class="form-control" id="valueCol" required />
        </div>
      </div>
      <div class="form-group row mt-3" *ngIf="loadPage2">
        <div class="col-3 no-padding"></div>
        <div class="col-3 zero-padding"></div>
        <label for="eventProcessedTimeCol" class="col-3 mandatory-field no-padding"><strong>Event Processed Time Col</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="eventProcessedTimeCol" class="form-control" id="eventProcessedTimeCol" required />
        </div>
      </div>
      <div class="form-group row mt-3" *ngIf="loadPage2">
        <label for="addSecret" class="col-12 no-padding alignCenter"><strong>Add Secret for Master Table</strong></label>
      </div>
      <div class="form-group row mt-3 margin-bottom-zero" *ngIf="!loadPage2 && datasourceDetailForm.get('datasourceTypeName').value == 'SQL Server'">
        <label for="datasourceConnStr" class="col-3 mandatory-field no-padding"><strong>ADO Connection Secret</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="datasourceConnStr" class="form-control" id="datasourceConnStr" required />
        </div>
        <label for="datasourceOdbcConnStr" class="col-3 mandatory-field no-padding"><strong>ODBC Connection Secret</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="datasourceOdbcConnStr" class="form-control" id="datasourceOdbcConnStr" required />
        </div>
      </div>
      <div class="form-group row mt-3 margin-bottom-zero" *ngIf="!loadPage2 && datasourceDetailForm.get('datasourceTypeName').value == 'SQL Server'">
        <label for="datasourceConnStrValue" class="col-3 mandatory-field no-padding"><strong>ADO Connection Secret Value</strong></label>
        <div class="col-3 zero-padding" [matTooltip]="data.data.datasourceConnStrValue">
          <input type="text" formControlName="datasourceConnStrValue" class="form-control" id="datasourceConnStrValue" required />
        </div>
        <label for="datasourceOdbcConnStrValue" class="col-3 mandatory-field no-padding"><strong>ODBC Connection Secret Value</strong></label>
        <div class="col-3 zero-padding" [matTooltip]="data.data.datasourceOdbcConnStrValue">
          <input type="text" formControlName="datasourceOdbcConnStrValue" class="form-control" id="datasourceOdbcConnStrValue" required />
        </div>
      </div>
      <div class="form-group row mt-3 margin-bottom-zero" *ngIf="!loadPage2 && datasourceDetailForm.get('datasourceTypeName').value == 'Cosmos DB'">
        <label for="cosmosDbApiUrl" class="col-3 mandatory-field no-padding"><strong>Cosmos Api URL Secret</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="cosmosDbApiUrl" class="form-control" id="cosmosDbApiUrl" required />
        </div>
        <label for="cosmosDbKey" class="col-3 mandatory-field no-padding"><strong>Cosmos Api Key Secret</strong></label>
        <div class="col-3 zero-padding" [matTooltip]="data.data.cosmosDbKey">
          <input type="text" formControlName="cosmosDbKey" class="form-control" id="cosmosDbKey" required />
        </div>

      </div>
      <div class="form-group row mt-3 margin-bottom-zero" *ngIf="!loadPage2 && datasourceDetailForm.get('datasourceTypeName').value == 'Cosmos DB'">
        <label for="cosmosDbApiUrlValue" class="col-3 mandatory-field no-padding"><strong>Cosmos Api URL Secret Value</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="cosmosDbApiUrlValue" class="form-control" id="cosmosDbApiUrlValue" required />
        </div>
        <label for="cosmosDbKeyValue" class="col-3 mandatory-field no-padding"><strong>Cosmos Api Key Secret Value</strong></label>
        <div class="col-3 zero-padding" [matTooltip]="data.data.cosmosDbKeyValue">
          <input type="text" formControlName="cosmosDbKeyValue" class="form-control" id="cosmosDbKeyValue" required />
        </div>
      </div>

      <div class="form-group row mt-3" *ngIf="loadPage2">
        <label for="masterDataConnStr" class="col-3 mandatory-field no-padding"><strong>ADO Connection Secret</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="masterDataConnStr" class="form-control" id="masterDataConnStr" required />
        </div>
        <label for="masterDataOdbcConnStr" class="col-3 mandatory-field no-padding"><strong>ODBC Connection Secret</strong></label>
        <div class="col-3 zero-padding">
          <input type="text" formControlName="masterDataOdbcConnStr" class="form-control" id="masterDataOdbcConnStr" required />
        </div>
      </div>
      <div class="form-group row mt-3" *ngIf="loadPage2">
        <label for="masterDataConnStrValue" class="col-3 mandatory-field no-padding"><strong>ADO Connection Secret Value</strong></label>
        <div class="col-3 zero-padding" [matTooltip]="data.data.masterDataConnStrValue">
          <input type="text" formControlName="masterDataConnStrValue" class="form-control" id="masterDataConnStrValue" required />
        </div>
        <label for="masterDataOdbcConnStrValue" class="col-3 mandatory-field no-padding"><strong>ODBC Connection Secret Value</strong></label>
        <div class="col-3 zero-padding" [matTooltip]="data.data.masterDataOdbcConnStrValue">
          <input type="text" formControlName="masterDataOdbcConnStrValue" class="form-control" id="masterDataOdbcConnStrValue" required />
        </div>
      </div>
      <div class="mb-2 text-align-right btnNext" *ngIf="!loadPage2">
        <button id="createBtn" type="submit" class="saveBtn2 primaryBtn" (click)="changePage(true)">Next</button>
      </div>
      <div class="mb-2 text-align-right" *ngIf="loadPage2">
        <button id="createBtn" type="submit" class="saveBtn2 primaryBtn" (click)="changePage(false)">Previous</button>
      </div>
      <div class="d-flex alignCenter">
        <button id="createBtn" type="submit" *ngIf="data.displayType != 'view'" class="actionBtn primaryBtn" (click)="saveDatasource()"
                [disabled]="disableSave()">
          Save
        </button>
      </div>
    </form>
  </div>
</div>
